var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "detail-card mx-3", attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs3: "", "ml-3": "" } },
            [
              _c("sub-navigation-title-duplicate", {
                attrs: {
                  icon: "immeuble_icon",
                  title: _vm.coCurrentBlockName,
                  source: _vm.coBlocks,
                  "is-loading": _vm.coFilterLoader
                },
                on: { click: _vm.handleBlockClick },
                model: {
                  value: _vm.dtMenu,
                  callback: function($$v) {
                    _vm.dtMenu = $$v
                  },
                  expression: "dtMenu"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta["edit_block"] || _vm.$route.meta["delete_block"]
            ? _c(
                "v-flex",
                {
                  staticClass: "actions-menu__wrapper",
                  attrs: { xs6: "", "text-xs-right": "" }
                },
                [
                  _c(
                    "v-menu",
                    {
                      staticClass: "pr-2 actions-menu__menu",
                      attrs: {
                        "offset-y": "",
                        bottom: "",
                        transition: "slide-x-transition",
                        "nudge-width": 350,
                        "close-on-content-click": false,
                        "content-class": "menu-content__block"
                      },
                      model: {
                        value: _vm.dtActionOpen,
                        callback: function($$v) {
                          _vm.dtActionOpen = $$v
                        },
                        expression: "dtActionOpen"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            fab: "",
                            dark: "",
                            small: "",
                            color: _vm.dtActionOpen ? "secondary" : "primary"
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("more_horiz")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { staticClass: "actions-menu__list" },
                        [
                          _c(
                            "v-list-tile",
                            {
                              attrs: {
                                disabled: !_vm.$route.meta["edit_block"]
                              },
                              on: { click: _vm.handleEditBlock }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.$route.meta["edit_block"]
                                          ? "primary"
                                          : "greyLight"
                                      }
                                    },
                                    [_vm._v("edit")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                {
                                  class: {
                                    disabled: !_vm.$route.meta["edit_block"]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(_vm.lblSetting.blockUpdate)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            staticClass: "actions-menu__divider",
                            attrs: { color: "fuchsia" }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            {
                              attrs: {
                                disabled: !_vm.$route.meta["delete_block"]
                              },
                              on: { click: _vm.handleDeleteBlock }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.$route.meta["delete_block"]
                                          ? "primary"
                                          : "greyLight"
                                      }
                                    },
                                    [_vm._v("delete")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                {
                                  class: {
                                    disabled: !_vm.$route.meta["delete_block"]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(_vm.lblSetting.blockDelete)
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "mt-2": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs10: "", "ml-4": "", "pl-2": "" } },
            [
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockOverallInformations)))
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("v-card", {
                    attrs: {
                      flat: "",
                      color: "secondary",
                      height: "1px",
                      width: "100%"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "detail-card",
          attrs: { row: "", wrap: "", "mx-3": "", "mt-2": "" }
        },
        [
          _c(
            "v-flex",
            {
              ref: "mapContainerRef",
              staticClass: "pa-0",
              style: _vm.dtStyle,
              attrs: { xs5: "", "ml-3": "", "mr-1": "" }
            },
            [
              !_vm.coInfosLoader
                ? _c(
                    "gmap-map",
                    {
                      staticStyle: { height: "100%", width: "100%" },
                      attrs: {
                        center: _vm.location
                          ? _vm.location
                          : { lat: 10, lng: 10 },
                        zoom: 7,
                        "map-type-id": "terrain"
                      }
                    },
                    [_c("gmap-marker", { attrs: { position: _vm.location } })],
                    1
                  )
                : _c(
                    "div",
                    { staticStyle: { width: "100%" } },
                    [
                      _c("block-infos-loader", {
                        attrs: { hasMargin: false, width: 400, height: 300 }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs9: "", "ml-2": "" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "pb-4": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs3: "" } },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockAddress)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              staticClass: "mt-1",
                              attrs: { column: "", wrap: "" }
                            },
                            [
                              !_vm.coInfosLoader
                                ? _c("label", { attrs: { for: "" } }, [
                                    _vm._v(_vm._s(_vm.address.line1))
                                  ])
                                : _c("block-infos-loader", {
                                    attrs: { height: 15, width: 300 }
                                  }),
                              _vm._v(" "),
                              !_vm.coInfosLoader
                                ? _c("label", { attrs: { for: "" } }, [
                                    _vm._v(_vm._s(_vm.address.line2))
                                  ])
                                : _c("block-infos-loader", {
                                    attrs: { height: 15, width: 300 }
                                  }),
                              _vm._v(" "),
                              !_vm.coInfosLoader
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.address.zip_code) +
                                        "         " +
                                        _vm._s(_vm.address.city)
                                    )
                                  ])
                                : _c("block-infos-loader", {
                                    attrs: { height: 15, width: 150 }
                                  }),
                              _vm._v(" "),
                              !_vm.coInfosLoader
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.address.country))
                                  ])
                                : _c("block-infos-loader", {
                                    attrs: { height: 15, width: 130 }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.$route.meta.hide_caretaker_info
                        ? _c(
                            "v-flex",
                            { attrs: { xs5: "", "pl-4": "" } },
                            [
                              !_vm.coInfosLoader
                                ? _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(_vm.lblSetting.blockCaretaker)
                                      ) +
                                        ": " +
                                        _vm._s(_vm.hasCaretaker)
                                    )
                                  ])
                                : [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(_vm.lblSetting.blockCaretaker)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("block-infos-loader", {
                                      attrs: { height: 10, width: 170 }
                                    }),
                                    _vm._v(" "),
                                    _c("block-infos-loader", {
                                      attrs: { height: 10, width: 130 }
                                    }),
                                    _vm._v(" "),
                                    _c("block-infos-loader", {
                                      attrs: { height: 10, width: 130 }
                                    })
                                  ],
                              _vm._v(" "),
                              _vm.coCaretakers.length && !_vm.coInfosLoader
                                ? _c("user-profile-enhanced-widget", {
                                    attrs: { user: _vm.coCaretakers[0] }
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs4: "" } },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockRef)))
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          !_vm.coInfosLoader
                            ? _c("span", [_vm._v(_vm._s(_vm.ref))])
                            : _c("block-infos-loader", {
                                attrs: {
                                  height: 10,
                                  width: 130,
                                  "has-margin": false
                                }
                              }),
                          _vm._v(" "),
                          _c("br"),
                          !_vm.coInfosLoader ? _c("br") : _vm._e(),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.$t(_vm.lblSetting.blockNumApartments))
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          !_vm.coInfosLoader
                            ? _c("span", [_vm._v(_vm._s(_vm.num_apartments))])
                            : _c("block-infos-loader", {
                                attrs: {
                                  height: 10,
                                  width: 130,
                                  "has-margin": false
                                }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "mt-4": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs5: "", "ml-4": "", "pl-2": "" } },
            [
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockStatistic)))
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("v-card", {
                    attrs: {
                      flat: "",
                      color: "secondary",
                      height: "1px",
                      width: "100%"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "mt-2": "", "mx-4": "", "pl-2": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                { staticClass: "pa-4" },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "mb-4": "" } },
                        [
                          _c("base-date-picker-range", {
                            attrs: { customClass: "detail-card__range-button" },
                            on: { change: _vm.handleChange },
                            model: {
                              value: _vm.dtSearchParam,
                              callback: function($$v) {
                                _vm.dtSearchParam = $$v
                              },
                              expression: "dtSearchParam"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs10: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  !_vm.coChartsLoader
                                    ? _c("GChart", {
                                        attrs: {
                                          type: "ColumnChart",
                                          data: _vm.coStatisticReportedData,
                                          options: _vm.getStatisticResolvedOptions(
                                            "blockReportedTicketStatistic"
                                          )
                                        }
                                      })
                                    : _c("chart-loader")
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  !_vm.coChartsLoader
                                    ? _c("GChart", {
                                        attrs: {
                                          type: "ColumnChart",
                                          data: _vm.coStatisticResolvedData,
                                          options: _vm.getStatisticResolvedOptions(
                                            "blockResolvedTicketStatistic",
                                            ""
                                          )
                                        }
                                      })
                                    : _c("chart-loader")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          !_vm.coChartsLoader
                            ? _c("GChart", {
                                attrs: {
                                  type: "PieChart",
                                  data: _vm.coTicketChartData.ticket,
                                  options: _vm.ticketChartDataOptions()
                                }
                              })
                            : _c("chart-loader")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "mx-4": "", "pl-2": "" } },
        [
          _vm.canManageDocuments
            ? _c(
                "v-flex",
                { attrs: { xs6: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "", "mt-4": "" } },
                    [
                      _c(
                        "v-flex",
                        [
                          _c("h1", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.lblSetting.blockRecentDocuments)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-card", {
                                attrs: {
                                  flat: "",
                                  color: "secondary",
                                  height: "1px",
                                  width: "100%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "px-3 mt-2 md12",
                          attrs: { width: "95%" }
                        },
                        [
                          _c(
                            "v-list",
                            { attrs: { "three-line": "" } },
                            _vm._l(_vm.coRecentDocs, function(item, index) {
                              return _c(
                                "v-list-tile",
                                { key: index },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { column: "" },
                                      on: {
                                        click: function(e) {
                                          return _vm.handleViewDocument(
                                            e,
                                            item.link
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                row: "",
                                                nowrap: "",
                                                "mb-2": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-avatar",
                                                {
                                                  staticClass: "ml-3 mt-2",
                                                  attrs: { color: "primary" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "headline white--text",
                                                      staticStyle: {
                                                        "font-size":
                                                          "15px !important"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "attachment_type"
                                                            )(item.name)
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "ml-4",
                                                  staticStyle: { width: "80%" }
                                                },
                                                [
                                                  !_vm.coDocumentsLoader
                                                    ? _c("strong", [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        )
                                                      ])
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mt-3 mb-2",
                                                          staticStyle: {
                                                            width: "100%"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "block-infos-loader",
                                                            {
                                                              attrs: {
                                                                height: 10,
                                                                width: 130
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                  _vm._v(" "),
                                                  !_vm.coDocumentsLoader
                                                    ? _c("br")
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !_vm.coDocumentsLoader
                                                    ? _c("p", {
                                                        staticStyle: {
                                                          margin: "0",
                                                          padding: "0",
                                                          color: "#999",
                                                          "font-size": "15px"
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.$t(
                                                              _vm.lblSetting
                                                                .blockDocumentText,
                                                              {
                                                                who:
                                                                  item.creator_name ||
                                                                  item.fk_media_entity,
                                                                when: item.when
                                                              }
                                                            )
                                                          )
                                                        }
                                                      })
                                                    : _c("block-infos-loader", {
                                                        attrs: {
                                                          height: 10,
                                                          width: 80
                                                        }
                                                      })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("hr", {
                                        attrs: {
                                          size: "1px",
                                          width: "100%",
                                          color: "#DDD"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    wrap: "",
                    "mt-4": "",
                    "ml-4": _vm.canManageDocuments
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs10: "", "pl-1": "" } },
                    [
                      _c("h1", { staticClass: "primary--text" }, [
                        _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockFavContacts)))
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs3: "" } },
                        [
                          _c("v-card", {
                            attrs: {
                              flat: "",
                              color: "secondary",
                              height: "1px",
                              width: "100%"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    wrap: "",
                    "justify-end": _vm.canManageDocuments
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mt-2", attrs: { width: "95%" } },
                    [
                      _c(
                        "v-carousel",
                        {
                          attrs: {
                            height: "250",
                            cycle: false,
                            light: true,
                            "hide-controls": _vm.favContacts.length < 3,
                            "hide-delimiters": _vm.favContacts.length < 3
                          }
                        },
                        _vm._l(_vm.favContactsIndexer, function(index, i) {
                          return _c(
                            "v-carousel-item",
                            { key: typeof index === "object" ? i : index },
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-center": "",
                                    "mt-4": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      class: {
                                        "xs4 pt-5 mt-4": _vm.coInfosLoader,
                                        xs5: !_vm.coInfosLoader
                                      },
                                      attrs: { "ml-2": "" }
                                    },
                                    [
                                      !_vm.coInfosLoader
                                        ? _c("user-profile-widget", {
                                            attrs: {
                                              user: _vm.favContacts[index]
                                            }
                                          })
                                        : _c("block-infos-loader", {
                                            attrs: { height: 220, width: "360" }
                                          })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      class: {
                                        "xs4 pt-5 mt-4": _vm.coInfosLoader,
                                        xs5: !_vm.coInfosLoader
                                      },
                                      attrs: { "ml-2": "" }
                                    },
                                    [
                                      _vm.favContacts[index + 1]
                                        ? [
                                            !_vm.coInfosLoader
                                              ? _c("user-profile-widget", {
                                                  attrs: {
                                                    user:
                                                      _vm.favContacts[index + 1]
                                                  }
                                                })
                                              : _c("block-infos-loader", {
                                                  attrs: { width: "360" }
                                                })
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "mt-4": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "ml-4": "", "pl-2": "" } },
            [
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.blockPendingDocuments)))
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("v-card", {
                    attrs: {
                      flat: "",
                      color: "secondary",
                      height: "1px",
                      width: "100%"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "mt-2": "", "mx-4": "", "pl-2": "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [_c("block-tickets", { attrs: { "has-filter": false } })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.$t(_vm.lblSetting.blockDeleteMessage, {
                block_name: _vm.currentBlock.name
              })
            },
            on: { cancel: _vm.handleDeleteCancel, delete: _vm.handleDeleteOK }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-039ea6b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039ea6b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/block/block-detail/template.html
// module id = null
// module chunks = 